import { useQuery } from '@tanstack/react-query';

import { ExportStatus, voiceToneService } from '@/services/VoiceTone';

export const GET_VOICE_TONE_EXPORTS_QUERY_KEY = ['voice-tone-exports'];

export function useGetVoiceToneExports() {
  const { data, isFetching, refetch } = useQuery({
    queryKey: GET_VOICE_TONE_EXPORTS_QUERY_KEY,
    queryFn: () => voiceToneService.listExports(),
    refetchInterval: (query) => {
      const exports = query.state.data;

      if (!exports || exports.length === 0) {
        return 600000;
      }

      const hasExportsInProgress = exports.some(
        (exp) => exp.status === ExportStatus.ACTIVE,
      );

      if (hasExportsInProgress) {
        return 10000;
      }

      return 300000;
    },
  });

  return {
    exports: data ?? [],
    isLoading: isFetching,
    refetch,
  };
}
